import React, { createContext, useContext, useState, useEffect } from 'react';

const ConfigContext = createContext({ isEmailPasswordAuthEnabled: false, isLoading: true });

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({ isEmailPasswordAuthEnabled: false, isLoading: true });

  useEffect(() => {
    // ENVIRONMENT AGNOSTIC: config.json already loaded synchronously in config-loader.js
    const initConfig = () => {
      try {
        if (window.CONFIG && window.CONFIG.default) {
          const remoteConfig = window.CONFIG;
          const appVersion = window.electronAPI?.appVersion || 'browser';
          
          console.log(`[ConfigContext] App Version: ${appVersion}`);
          console.log('[ConfigContext] Using pre-loaded CONFIG:', remoteConfig);

          // Find rule for our version
          const rule = remoteConfig.versionRules?.find(r => r.version === appVersion);

          let finalConfig;
          if (rule) {
            // Found special rule for this version
            finalConfig = { ...remoteConfig.default, ...rule };
            console.log(`[ConfigContext] Applied version-specific rule for v${appVersion}:`, finalConfig);
          } else {
            // Rule not found, using default
            finalConfig = remoteConfig.default;
            console.log('[ConfigContext] No specific rule found, using default config:', finalConfig);
          }
          
          setConfig({ ...finalConfig, isLoading: false });
        } else {
          console.error('[ConfigContext] window.CONFIG not found, using fallback');
          setConfig({ isEmailPasswordAuthEnabled: false, isLoading: false });
        }
      } catch (error) {
        console.error('[ConfigContext] Error processing config:', error);
        setConfig({ isEmailPasswordAuthEnabled: false, isLoading: false });
      }
    };

    initConfig();
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};
